import { HTTP, authHeader } from './http-service';

class CaseManagementService {
  getByMeasures(umrs) {
    return HTTP.post('/CaseManagement/by-measures', { umrs }, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getByAddress(addressLine1, postcode) {
    return HTTP.post('/CaseManagement/by-address', { addressLine1, postcode }, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getComplaint(complaintNumber) {
    return HTTP.get(`/CaseManagement/complaint/${complaintNumber}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new CaseManagementService();
